import { DataConnectionType } from './types.ts';
import type { DataTypeValue } from './types.ts';

export const DATA_SOURCE_ACTION_KEYS = {
    load: 'DATA_SOURCES_LOAD',
    save: 'DATA_SOURCES_SAVE',
    delete: 'DATA_SOURCES_DELETE',
    testConnection: 'DATA_SOURCES_TEST_CONNECTION',
    discoverSchema: 'DATA_SOURCES_DISCOVER_SCHEMA',
} as const;

export const DATA_TYPE_OPTIONS: { value: DataTypeValue; labelKey: string }[] = [
    { value: 'text', labelKey: 'facility:dataSources.dataTypes.text' },
    { value: 'number', labelKey: 'facility:dataSources.dataTypes.number' },
    { value: 'date', labelKey: 'facility:dataSources.dataTypes.date' },
    { value: 'boolean', labelKey: 'facility:dataSources.dataTypes.boolean' },
    { value: 'url', labelKey: 'facility:dataSources.dataTypes.url' },
];

export const FILE_PROVIDER_DATA_TYPE_OPTIONS = DATA_TYPE_OPTIONS;

export const LOCKED_PROVIDER_TEXT_OPTIONS = DATA_TYPE_OPTIONS.filter(option => option.value === 'text' || option.value === 'url');

export const FILE_PROVIDER_TYPES = new Set<DataConnectionType>([
    DataConnectionType.Csv,
    DataConnectionType.Excel,
    DataConnectionType.MsAccess,
]);

export const FULLY_EDITABLE_PROVIDER_TYPES = new Set<DataConnectionType>([
    DataConnectionType.Csv,
    DataConnectionType.Excel,
]);

export const URL_ONLY_EDITABLE_PROVIDER_TYPES = new Set<DataConnectionType>([
    DataConnectionType.MsAccess,
    DataConnectionType.MsSqlServer,
    DataConnectionType.PostgreSql,
]);

export const SQL_PROVIDER_TYPES = new Set<DataConnectionType>([
    DataConnectionType.MsSqlServer,
    DataConnectionType.PostgreSql,
]);
